<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import { popupDocument } from '../../../../Helpers/popupContent'
const props = defineProps<{ html: string; css: string; language: string; title: string }>()
const frame = ref<HTMLIFrameElement>()
const height = ref(280)
const document = computed(() => popupDocument({ html: props.html, css: props.css }, props.language))
let observer: ResizeObserver | undefined
const resize = () => {
  const body = frame.value?.contentDocument?.body
  if (body) height.value = Math.max(80, Math.min(Math.ceil(body.scrollHeight), Math.floor(window.innerHeight * 0.65)))
}
const loaded = () => {
  observer?.disconnect()
  const body = frame.value?.contentDocument?.body
  if (!body) return
  observer = new ResizeObserver(resize)
  observer.observe(body)
  resize()
}
onMounted(() => window.addEventListener('resize', resize))
onBeforeUnmount(() => { observer?.disconnect(); window.removeEventListener('resize', resize) })
</script>

<template>
  <iframe ref="frame" :title="title" :srcdoc="document" sandbox="allow-same-origin allow-top-navigation-by-user-activation" referrerpolicy="no-referrer" :style="{ height: `${height}px` }" @load="loaded" />
</template>

<style scoped>
iframe { display: block; width: 100%; border: 0; background: white; }
</style>
